import React from "react";
import '../css/footer.css';

function FooterComponent(props) {
    return (
        <>
   <footer className="footer-nw">
              <div className="mxwidth">
                <span className="footer-nw-cprght">©Network18. All rights reserved.</span>
                {/* <ul className="footer-nw-menu">
                    <li className="footer-nw-item"><a className="footer-nw-link" target="_blank" href="https://www.moneycontrol.com/cdata/privacypolicy.php">Privacy Policy</a></li>
                    <li className="footer-nw-item"><a className="footer-nw-link" target="_blank" href="https://www.moneycontrol.com/cdata/termsofuse.php">Terms & Conditions</a></li>
                    <li className="footer-nw-item"><a className="footer-nw-link" target="_blank" href="https://www.moneycontrol.com/cdata/disclaim.php">Disclaimer</a></li>
                </ul> */}
              </div>
        </footer>
                    </>
                    

    )
}
export default FooterComponent;